import React, { useMemo } from 'react';
import { keyframes } from "@emotion/react";
import styled from "@emotion/styled";
import { Color, SizeName } from "@mrocket/styles";
import { forwardRefPolymorphic } from "@mrocket/utils";

interface SpinnerProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: SizeName
  color?: Color
}

/**
 * Spinner loading component
 */
export const Spinner = forwardRefPolymorphic<
  'div',
  SpinnerProps
>((
  {
    size,
    color = 'currentColor'
  }, ref
) => {

  const sizeIcon = useMemo(() => getSize(size), [size])

  return (
    <SpinnerRoot
      ref={ref}
      size={size}
      style={{width: sizeIcon, height: sizeIcon}}
    >
      <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width: "100%", height: "100%"}}>
        <Path
          d="M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z"
          fill={color}
        />
      </svg>
    </SpinnerRoot>
  );
})

const getSize = (size: SizeName) => {
  switch (size) {
    case 'tiny':
      return 14;
    case 'small':
      return 18;
    case 'medium':
    default:
      return 24;
    case 'large':
      return 36;
  }
}

const spin = keyframes`
  100% {
    transform: rotate(360deg)
  }
`

const SpinnerRoot = styled('div')<SpinnerProps>`
  user-select: none;
  width: auto;
  height: auto;
  overflow: hidden;
  display: inline-block;
  text-align: center;
  flex-shrink: 0;
  color: inherit;

`

const Path = styled.path`
  transform-origin: center;
  animation: ${spin} .75s infinite linear;
`
